import React from 'react';
import { Alert, LoadingSpinner, TextInput, Button, Row, Col , Link} from '@paypalcorp/pp-react';
import * as FPT from '../../utility/fpt';
import { launchRedirect } from '../../lib/validate';
import { hide, show } from '../../common/domUtils';
import withTheme from '../../common/withTheme';

class Trackdonation extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			loader: false,
			propertyInfo: this.props.propertyInfo,
			isResult: this.props.isResult || false,
			trackAnother: this.props.trackanother || false,
			transactionId: ''
		};
		this.formSubmit = this.formSubmit.bind(this);
	}

	componentDidMount() {
		hide('.loader');
		const self = this;
		document.getElementById('transactionId').addEventListener('keydown', function (e) {
			if (e.which == 13) {
				const transactionId = document.querySelector("#transactionId").value.trim();
				FPT.trackButtonClickWithData('submitTransactionIdBtn', {pageParams: {transactionId: transactionId, trackAnother: true}});
				if (transactionId !== "") {
					show('.loader');
					const submitUrl = `/givingfund/donationtracker?transactionID=${transactionId}&trackanother=true`;
					launchRedirect(submitUrl);
				}
			}
		});
		FPT.trackPage('main:givingfund:donationtracker');
	}

	formSubmit() {
		const self = this;
		const transactionId = document.querySelector("#transactionId").value.trim();
		FPT.trackButtonClickWithData('submitTransactionIdBtn', {pageParams: {transactionId: transactionId, trackAnother: true}});
		if (transactionId !== "") {
			show('.loader');
			const formSubmitUrl = `/givingfund/donationtracker?transactionID=${transactionId}&trackanother=true`;
			launchRedirect(formSubmitUrl);
		}
	}

	render() {
		let propertyInfo = this.state.propertyInfo,
		showFormHeadline = (<h1>{propertyInfo.trackdonation.trackanotherdonation}</h1>);
		if (!this.state.isResult && this.state.trackAnother) {
			showFormHeadline = (<Alert id="trackDonationError" type="error">{propertyInfo.trackdonation.errorMessage} <Link inverse href="contact">{propertyInfo.trackdonation.contactus}</Link></Alert>);
		} else if (!this.state.isResult && !this.state.trackAnother) {
			showFormHeadline = ('');
		}
		return (
			<section className="gray">
				<LoadingSpinner size="lg" className="loader" screenReaderText={propertyInfo.trackdonation.loading} />
				<div id="trackdonation">
					<Row>
						<Col form="3qtr">{showFormHeadline}</Col>
					</Row>
					<Row>
						<Col>
							<TextInput label={propertyInfo.trackdonation.entertransactionid} id="transactionId" value={this.state.transactionId} />
						</Col>
						<Col md="auto">
							<Button onClick={this.formSubmit} id="lookupBtn" className="hidden-xs">{propertyInfo.trackdonation.lookup}</Button>
						</Col>
					</Row>
				</div>
			</section>
		);
	}
}
export default withTheme(Trackdonation);
